import { FC } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { metaTitle } from '../../../util/tabTitle';
import AuthShell from '../AuthShell';

const ForgotPasswordPage: FC = () => {
  metaTitle('Forgot Password');
  return (
    <AuthShell
      title="Reset your password"
      subtitle="Your organization administrator can securely reset your access."
    >
      <Stack spacing={2}>
        <Typography color="text.secondary" textAlign="center">
          Contact your administrator and ask them to issue a temporary password.
          You can change it after signing in.
        </Typography>
        <Button
          component={RouterLink}
          to="/sign-in"
          variant="contained"
          sx={{ minHeight: 42 }}
        >
          Back to sign in
        </Button>
      </Stack>
    </AuthShell>
  );
};

export default ForgotPasswordPage;
